import apisauce from 'apisauce';
import api from './base';
import buildConfig from '../utils/buildConfig';

const uploadImage = (file: Blob) => {
  const body = new FormData();
  body.append('temp[file]', file);

  const uploadApi = apisauce.create({
    baseURL: buildConfig.api,
    headers: {
      ...api.headers,
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
    timeout: 15000,
  });

  return uploadApi.post('v1/temps', body);
};

export default {
  uploadImage,
};
